import { useQuery } from "@tanstack/react-query";
import { PermissionLevel } from "./types";
import { getCurrentUserEmail } from "@/lib/auth";
import { getUserByEmail } from "@/services/userManagementApi";

export const useCurrentUserPermissions = () => {
  return useQuery({
    queryKey: ["user_permissions"],
    queryFn: async (): Promise<Record<string, PermissionLevel>> => {
      const email = getCurrentUserEmail();
      if (!email) return {};
      try {
        const user = await getUserByEmail(email);
        // If user has admin role, grant edit on everything
        if (user.roles?.some((r: string) => r.toLowerCase().includes('admin'))) {
          return { '*': 'edit' };
        }
        return {};
      } catch {
        return {};
      }
    },
  });
};

export const useHasPermission = (resourceName: string, requiredLevel: PermissionLevel = 'view') => {
  const { data: permissionMap, isLoading } = useCurrentUserPermissions();
  
  // Wildcard admin check
  if (permissionMap?.['*'] === 'edit') {
    return { hasPermission: true, isLoading };
  }

  const userPermission = permissionMap?.[resourceName] || 'none';
  
  const hasPermission = userPermission === 'edit' || 
    (userPermission === 'view' && requiredLevel === 'view');
  
  return { hasPermission, isLoading };
};
